// extracted by mini-css-extract-plugin
export var avatarContainer = "_cb-0";
export var avatarTypingWave = "_cb-i";
export var gray = "_cb-f";
export var green = "_cb-c";
export var icon = "_cb-9";
export var image = "_cb-1";
export var lg = "_cb-6";
export var md = "_cb-5";
export var presenceDot = "_cb-b";
export var red = "_cb-d";
export var sm = "_cb-4";
export var status = "_cb-a";
export var typingDot = "_cb-h";
export var typingPill = "_cb-g";
export var xl = "_cb-7";
export var xs = "_cb-3";
export var xxl = "_cb-8";
export var xxs = "_cb-2";
export var yellow = "_cb-e";